// /providers/UserContext.jsx
import { createContext, useCallback, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "token-mail";
const getApiBase = () =>
  window.location.href.includes("localhost")
    ? "http://localhost:8000"
    : "https://v2.turbosify.com";

export const UserContext = createContext({
  token: "",
  isAuthenticated: false,
  login: async (_email, _password) => {},
  logout: () => {},
  setToken: (_t) => {},
  activeTool: "select",
  setActiveTool: (_t) => {},
});

export function UserProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY) || "");
  const [activeTool, setActiveTool] = useState("Remove BG");

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) {
        setToken(e.newValue || "");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [token]);

  const apiBase = useMemo(getApiBase, []);
  const isAuthenticated = !!token;

  const login = useCallback(
    async (email, password) => {
      const res = await fetch(`${apiBase}/mail/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        const msg = await safeReadError(res);
        throw new Error(msg || "Đăng nhập thất bại");
      }

      const data = await res.json();
      const t = data.token || data.access_token || "";
      if (!t) throw new Error("Không nhận được token");

      setToken(t);
      return t;
    },
    [apiBase]
  );

  const logout = useCallback(() => {
    setToken("");
  }, []);

  const value = useMemo(
    () => ({
      token,
      isAuthenticated,
      login,
      logout,
      setToken,
      activeTool,
      setActiveTool,
    }),
    [token, isAuthenticated, login, logout, activeTool]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

async function safeReadError(res) {
  try {
    const txt = await res.text();
    if (!txt) return "";
    try {
      const json = JSON.parse(txt);
      return json.message || json.error || txt;
    } catch {
      return txt;
    }
  } catch {
    return "";
  }
}
